import { getLoyaltyLevelNumber } from '~~/helpers/getLoyaltyLevelNumber';
import type { LoyaltyLevel } from '~~/types/loyaltyLevel/loyaltyLevel';
import type { CustomerDataPlatformLevel, PartnersLevel } from '~~/types/partnersLevels/partnersLevels';

/**
 * Joins the shop's commercetools levels (discount %, already filtered to levels active in the store)
 * with the CDP thresholds by level number. A level missing on either side is left out.
 */
export const buildPartnersLevels = (
  loyaltyLevels: readonly LoyaltyLevel[],
  customerDataPlatformLevels: readonly CustomerDataPlatformLevel[],
): PartnersLevel[] => customerDataPlatformLevels
  .map(({ groupKey, minPoints, minAmount }) => {

    const levelNumber = getLoyaltyLevelNumber(groupKey);
    const loyaltyLevel = loyaltyLevels.find((level) => level.levelNumber === levelNumber);

    return loyaltyLevel
      ? { levelNumber, discountPercentage: loyaltyLevel.discountPercentage, minPoints, minAmount }
      : null;

  })
  .filter((level): level is PartnersLevel => level !== null)
  .sort((a, b) => a.levelNumber - b.levelNumber);
